// ──────────────────────────────────────────────────────────────────────────
// MiniToggle.js — Mini-toggle a 2+ stati in mini-pillola.
//
// Pattern UX consolidato in v130 (D115 — drawdown vs picco/inizio).
// Estratto in v131 per riuso tra sotto-tab. Logica e stili identici
// all'originale di DiarioStatisticheSintesi.js, byte-per-byte.
//
// Props:
//   - valori:   array di {id, label}
//   - attivo:   id del valore attivo
//   - onChange: callback (idNuovo) => void
// ──────────────────────────────────────────────────────────────────────────

export default function MiniToggle({ valori, attivo, onChange }) {
  return (
    <span style={{
      display: "inline-flex", background: "#eef2f7",
      borderRadius: 6, padding: 2,
    }}>
      {valori.map((v) => (
        <button
          key={v.id}
          type="button"
          onClick={() => onChange(v.id)}
          style={{
            background: attivo === v.id ? "#fff" : "transparent",
            color: attivo === v.id ? "#1f2a37" : "#6b7280",
            border: attivo === v.id ? "1px solid #d6dde6" : "1px solid transparent",
            borderRadius: 4, padding: "2px 8px",
            fontSize: 10.5, fontWeight: attivo === v.id ? 600 : 400,
            cursor: "pointer", lineHeight: 1.4,
          }}
        >{v.label}</button>
      ))}
    </span>
  );
}
